{
	"abilities": {
		"admins_manage": "Gestisci admin"
	},
	"actions": {
		"edit_abilities": "Modifica abilità",
		"open_menu": "Apri menu azioni",
		"request_password_reset": "Richiedi reset password",
		"resend_invite": "Reinvia email di invito"
	},
	"columns": {
		"abilities": "Abilità",
		"actions": "Azioni",
		"id": "ID",
		"status": "Stato"
	},
	"delete_admin": {
		"description": "Elimina definitivamente l'account di {{email}}. Operazione irreversibile.",
		"success": "Account admin eliminato.",
		"title": "Elimina account admin"
	},
	"edit_abilities": {
		"description": "Aggiorna le abilità concesse a {{email}}.",
		"submit": "Salva abilità",
		"success": "Abilità aggiornate.",
		"title": "Modifica abilità admin"
	},
	"empty_description": "Invita un membro del team per dargli accesso.",
	"empty_title": "Nessun amministratore",
	"filters": {
		"field": {
			"abilities": "Abilità"
		}
	},
	"invite": {
		"abilities": "Abilità",
		"abilities_placeholder": "Seleziona le abilità",
		"abilities_search_empty": "Nessuna abilità trovata",
		"button": "Invita admin",
		"description": "Invia un'email di invito a un nuovo admin.",
		"email_placeholder": "nome@esempio.it",
		"error": "Impossibile invitare l'admin.",
		"name_placeholder": "Nome completo",
		"submit": "Invia invito",
		"success": "Admin invitato con successo.",
		"title": "Invita un nuovo admin",
		"validation": {
			"abilities_invalid": "Seleziona almeno un'abilità",
			"email_invalid": "Inserisci un'email valida",
			"name_invalid": "Il nome è obbligatorio"
		}
	},
	"page_title": "Admin",
	"request_password_reset": {
		"confirm": "Invia link di reset",
		"description": "Invia un link per il reset della password a {{email}}. La password attuale rimane valida finché non ne sceglie una nuova.",
		"success": "Link di reset password inviato.",
		"title": "Richiedi reset password"
	},
	"resend_invite": {
		"confirm": "Reinvia invito",
		"description": "Reinvia l'email di invito a {{email}}. Il link precedente verrà invalidato.",
		"success": "Invito reinviato.",
		"title": "Reinvia email di invito"
	},
	"search_placeholder": "Cerca admin...",
	"status": {
		"active": "Attivo",
		"disabled": "Disabilitato",
		"pending": "Invito in sospeso"
	}
}
